/**
 * @copyright @2024 Dream Team Cell C. All rights reserved.
 * @description Page to define the format font size functions.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 24/Apr/2024
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/**
 * function to convert font size from rem to px
 *
 * @param {string} value - font size value in rem
 * @return {number}
 */
export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

/**
 * function to convert font size from px to rem
 *
 * @param {string} value - font size value in px
 * @return {string}
 */
export function pxToRem(value) {
  return `${value / 16}rem`;
}
